import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MicroQualificationService from "../../services/MicroQualificationService";

let initialState = {
    data: null,
    isLoading: false,
    error: null,
}

export const getMicroQualificationById = createAsyncThunk(
    'getMicroQualificationById',
    async ({id}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await MicroQualificationService.getMicroQualificationById(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const microQualificationSaveSlice = createSlice({
    name: 'microQualificationSaveSlice',
    initialState,
    reducers: {
        setMicroQualification(state, action) {
            state.data = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMicroQualificationById.pending, (state) => {
                state.isLoading = true;
                state.data = null;
                state.error = null;
            })
            .addCase(getMicroQualificationById.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
            })
            .addCase(getMicroQualificationById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
    }
});

export const {
    setMicroQualification
} = microQualificationSaveSlice.actions;

export default microQualificationSaveSlice.reducer;